export enum TransactionType {
  INVOICE = "INVOICE",
  PAYMENT = "PAYMENT",
  WAIVER = "WAIVER",
  OPENING_BALANCE = "OPENING_BALANCE",
  REFUND = "REFUND",
}
